import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import WorkIcon from '@mui/icons-material/Work';
import BusinessIcon from '@mui/icons-material/Business';
import ShieldIcon from '@mui/icons-material/Shield';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  togglePinnedFiltersState,
  selectServicePointsPinnedFilters,
} from '@store';

export const useServicePointsFilterConfig = ({ enums }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectServicePointsPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'status',
        label: 'Status',
        icon: RadioButtonUncheckedIcon,
        options: enums?.statuses || [],
        multiSelect: false,
      },
      {
        id: 'certified',
        label: 'Certified',
        icon: CheckCircleIcon,
        options: enums?.certifiedOptions || [],
        multiSelect: false,
      },
      {
        id: 'workType',
        label: 'Work Types',
        icon: WorkIcon,
        options: enums?.workTypes || [],
        multiSelect: true,
      },
      {
        id: 'manufacturer',
        label: 'Brand',
        icon: BusinessIcon,
        options: enums?.brands || [],
        multiSelect: true,
      },
      {
        id: 'insurance',
        label: 'Insurances',
        icon: ShieldIcon,
        options: enums?.insurances || [],
        multiSelect: true,
      },
    ],
    [enums]
  );
  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({ board: 'servicePoints', pinnedFilter })
    );
  };

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      certified: parseQueryValue(router.query.certified),
      status: parseQueryValue(router.query.status),
      workType: parseQueryValue(router.query.workType),
      manufacturer: parseQueryValue(router.query.manufacturer),
      insurance: parseQueryValue(router.query.insurance),
    };
  }, [router.query]);

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
  };
};
